import { createFileRoute } from "@tanstack/react-router";
import { EsPlaceholder, esHead } from "@/knowmeno/marketing/EsPlaceholder";

export const Route = createFileRoute("/es/terminos")({
  head: () => esHead({
    path: "/terminos",
    title: "Términos de Servicio | SepaMeno",
    description: "Términos de uso de SepaMeno.",
    englishPath: "/terms",
  }),
  component: () => (
    <EsPlaceholder
      title="Términos de Servicio"
      subtitle="Versión en español próximamente. La versión en inglés aplica mientras tanto."
      englishHref="https://knowmeno.com/terms"
    />
  ),
});
